// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/style/print.css);"]);
// Module
exports.push([module.id, ".el-form .el-table .cell .el-form-item__content[data-v-93357e14] {\n  line-height: normal;\n}", ""]);
// Exports
module.exports = exports;
